import { TDoor } from 'shared/types/doors';
import { DoorContent } from '../DoorContent';

export const FifthDoorContent: React.FC<TDoor> = props => {
  return (
    <DoorContent btnText="Узнать предсказание" {...props}>
      <div>
        <b>🔮 Загадайте желание на 2026 год</b>
      </div>
      <div>
        Новый год — время чудес, искрящегося настроения и, конечно, светлых надежд на будущее! Загляните в будущее и
        получите предсказание на 2026 год — просто потрясите наш виртуальный <b>снежный шар!</b> Пусть вам повезёт! 🫶🏻
      </div>
      <div>
        <b>А чтобы начать год уверенно,</b> действуйте наверняка. <b>Продвижение объявлений</b> поможет вашим объектам
        сиять ярче новогодних гирлянд и привлекать стабильный поток клиентов весь год.
      </div>
      <div>
        <i>Пусть предсказание вас порадует, а продвижение приносит отличные результаты весь год! ✨</i>
      </div>
    </DoorContent>
  );
};
